import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';

export function ContentHomeCashTypeMoreButton({
  isMobile,
  maxDiscountRate,
  onClickSetMore,
  ...props
}: {
  isMobile?: boolean;
  maxDiscountRate: number;
  onClickSetMore: () => void;
}) {
  return (
    <button
      {...props}
      className={twMerge(
        'flex h-48pxr items-center justify-between rounded-8pxr',
        isMobile && 'bg-theme-solid-10 px-18pxr',
        !isMobile &&
          'border border-solid border-theme-transparent-20 bg-theme-solid-0 pl-16pxr pr-12pxr'
      )}
      onClick={e => {
        LOG_CLICK_EVENT('세트상품더보기_클릭', e, onClickSetMore);
      }}
    >
      <div className="flex items-center">
        <Icon type={IconType.ContentHomeSaleset} className="mb-1pxr" />
        <Text
          className={twMerge(
            'ml-6pxr text-theme-solid-100',
            isMobile ? 'font-small1-bold' : 'font-small2-bold'
          )}
        >
          {maxDiscountRate > 0 ? (
            <>
              {t('contenthome_sethome_button_discount', {
                values: {value: maxDiscountRate},
              })}
            </>
          ) : (
            t('contenthome_sethome_button_no_discount')
          )}
        </Text>
      </div>
      <Icon type={IconType.ContentHomeArrowSolid} />
    </button>
  );
}
